export default __webpack_public_path__ + "static/media/download.a194fb47.png";